var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasClipboard)?_c('span',[_c('q-icon',{attrs:{"name":"las la-copy","size":_vm.size || 'sm'},on:{"click":_vm.copy}}),_c('q-tooltip',{attrs:{"no-parent-event":""},model:{value:(_vm.tt),callback:function ($$v) {_vm.tt=$$v},expression:"tt"}},[_vm._v("copied")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }